/** @jsxImportSource @emotion/react */
import React from 'react'

import * as styles from './styles'

export default function Emoji30() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 45 45" css={styles.svg}>
      <g transform="matrix(1,0,0,1,-505.139,-3294)">
        <g transform="matrix(0.683279,0,0,0.683279,373.769,3232.44)">
          <g transform="matrix(0.937093,0,0,0.937093,-44.0893,-73.6606)">
            <g opacity="0.75">
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M286.83,174.25c-19.266,0.016 -35.11,15.874 -35.11,35.14c0,19.277 15.863,35.14 35.14,35.14c19.277,0 35.14,-15.863 35.14,-35.14c-0.022,-19.269 -15.871,-35.118 -35.14,-35.14m0,65.88c-16.869,0 -30.75,-13.881 -30.75,-30.75c0,-16.869 13.881,-30.75 30.75,-30.75c16.869,0 30.75,13.881 30.75,30.75c0,0.003 0,0.007 0,0.01c-0.016,16.861 -13.889,30.729 -30.75,30.74"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M268.28,200.37l8.79,4.39c0.31,0.157 0.653,0.236 1,0.23c0,0 0.001,0 0.001,0c1.207,0 2.2,-0.993 2.2,-2.2c0,-0.826 -0.465,-1.585 -1.201,-1.96l-8.78,-4.39c-0.31,-0.158 -0.652,-0.24 -1,-0.24c-1.21,0 -2.205,0.995 -2.205,2.205c0,0.828 0.467,1.589 1.205,1.965"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M303.42,196.44l-8.78,4.39c-0.747,0.371 -1.221,1.136 -1.221,1.97c0,1.207 0.993,2.2 2.2,2.2c0.007,0 0.014,0 0.021,0c0.348,0.001 0.691,-0.081 1,-0.24l8.79,-4.39c0.738,-0.376 1.205,-1.137 1.205,-1.965c0,-1.21 -0.995,-2.205 -2.205,-2.205c-0.348,0 -0.69,0.082 -1,0.24"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M286.83,213.78c-7.69,0 -15.49,3.92 -19.39,9.76c-0.295,0.384 -0.455,0.856 -0.455,1.34c0,1.207 0.993,2.2 2.2,2.2c0.785,0 1.513,-0.42 1.905,-1.1c3.08,-4.6 9.55,-7.81 15.74,-7.81c6.19,0 12.67,3.21 15.75,7.81c0.664,0.978 2.007,1.251 3,0.61c1.004,-0.669 1.279,-2.046 0.61,-3.05c-3.91,-5.84 -11.7,-9.76 -19.4,-9.76"
                  css={styles.svg}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
